import axios from 'axios';
import { API_URL } from '../constant';

const API_BASE_URL = API_URL || 'https://staging.api.topcoinuk.com/api';

// Create axios instance with auth headers
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const accountAdminService = {
  // Get all account admins with pagination and filters
  getAllAccountAdmins: async (params = {}) => {
    const response = await api.get('/superadmin/account-admins', { params });
    return response.data;
  },

  // Get specific account admin details
  getAccountAdmin: async (userId) => {
    const response = await api.get(`/superadmin/account-admins/${userId}`);
    return response.data;
  },

  // Create new account admin
  createAccountAdmin: async (adminData) => {
    const response = await api.post('/superadmin/account-admins', adminData);
    return response.data;
  },

  // Check email availability
  checkEmailAvailability: async (email) => {
    const response = await api.post('/superadmin/account-admins/check-email-availability', { email });
    return response.data;
  },
};
